module.exports = __webpack_public_path__ + "static/media/health2.c2934ad3.jpg";